import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import ActiveHelper from '../../../components/common/activeHelper';
import { Colxx } from '../../../components/common/CustomBootstrap';
import { ORDER_COLLECTION } from '../../../config/env';
import { firestore } from '../../../helpers/Firebase';
import { accessTypes, accessTypesObject, createNotification } from '../../../helpers/Utils';
import AddNewAppointment from './components/AddNewAppointment';
import Order from './components/order';
// import './appointments.css';

const Requests = () => {
  // const { bookings, washers, provider, activeServices } = useSelector(state => state.providers);
  const { provider, washers, bookings, services, advServices, } = useSelector(state => state.providers)

  const { user } = useSelector(state => state.authUser);
  const search = useSelector(state => state.settings.search) || '';
  const [selectedBooking, setSelectedBooking] = useState(false);
  const [activeServices, setActiveServices] = useState({});
  const [filters, setFilters] = useState({});
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [createNewOrder, setCreateNewOrder] = useState(false);
  const [acceptAction, setAcceptAction] = useState(false);
  const [quickWashAssignmentModal, setQuickWashAssignmentModal] = useState(false);
  const [selectedSP, setSelectedSP] = useState(null);
  const [selectedWasher, setSelectedWasher] = useState(null);
  const [rejectionReason, setRejectionReason] = useState('');
  const [rejectAction, setRejectAction] = useState(false);
  console.log('filters', filters, filteredBookings)

  // Comprehensive filtering logic
  useEffect(() => {
    let filteredBookings = Object.values(bookings || {})
      ?.filter(rec => ['new', 'pending'].includes(rec.status) || rec.reassigning === true)
      ?.sort((a, b) => (Number(b.reassigning === true) - Number(a.reassigning === true)) || (a.created - b.created));

    // Filter by providers - only apply if providers filter has items
    if (filters?.providers && filters.providers.length > 0) {
      filteredBookings = filteredBookings.filter(rec =>
        filters.providers.includes(rec.sp_id)
      );
    }

    // Filter by services - only apply if services filter has items
    if (filters?.services && filters.services.length > 0) {
      filteredBookings = filteredBookings.filter(rec =>
        filters.services.includes(rec.service_id)
      );
    }

    // Filter by washers - only apply if washers filter has items
    if (filters?.washers && filters.washers.length > 0) {
      filteredBookings = filteredBookings.filter(rec =>
        filters.washers.includes(rec.washer_id)
      );
    }

    // Filter by status (additional status filtering if needed)
    if (filters?.status && filters.status.length > 0) {
      filteredBookings = filteredBookings.filter(rec =>
        filters.status.includes(rec.status)
      );
    }

    // Search filter - search across multiple fields
    if (search && search.trim()) {
      const searchLower = search.toLowerCase().trim();
      filteredBookings = filteredBookings.filter(rec => {
        return (
          (rec?.customer_name?.toLowerCase().includes(searchLower)) ||
          (rec?.customer_number?.toLowerCase().includes(searchLower)) ||
          (rec?.service_name?.toLowerCase().includes(searchLower)) ||
          (rec?.washer_name?.toLowerCase().includes(searchLower)) ||
          (rec?.sp_name?.toLowerCase().includes(searchLower)) ||
          (rec?.status?.toLowerCase().includes(searchLower))
        );
      });
    }

    setFilteredBookings(filteredBookings);
  }, [filters, bookings, search]);
  useEffect(() => {
    let allServices = Object.values(services || {})?.concat(Object.values(advServices || {}))
    const updatedActiveServices = {};
    Object.values(washers || {}).forEach(washer => {
      if (washer.activeServices) {
        const activeServiceKeys = Object.keys(washer.activeServices);
        const filteredServices = allServices.filter(service => activeServiceKeys.includes(service.key));
        filteredServices.forEach(service => {
          updatedActiveServices[service.key] = {
            ...service,
            modifier: washer.activeServices[service.key],
            label: service.name,
            value: service.name
          };
        });
      }
    });
    setActiveServices(updatedActiveServices);
  }, [services, advServices, washers]);

  const tableColumns = useMemo(() => {
    return [
      {
        Header: "Booking Date", accessor: "bookingDate",
        type: 'appointmentDate'
      },
      { Header: "Service Provider", accessor: "sp_name", type: 'label', show: accessTypes.includes(user?.accessType) },
      { Header: "Customer", accessor: "customer_name", type: 'customer', showCustomerNumber: accessTypes.includes(user?.accessType) },
      { Header: "Service Name", accessor: "service_name", type: 'label' },
      { Header: "Worker Name", accessor: "washer_name", type: 'label' },
      { Header: "Status", accessor: "status", type: 'orderStatus', },


    ];
  }, [user?.accessType]);

  const toggleModal = () => {
    setSelectedBooking(false)
  };
  const dismiss = () => {
    setSelectedBooking(false)
  };

  // Create filter components for filtering
  const filterComponent = useMemo(() => {
    const filterComponents = [];

    // Service Provider filter (only for admin users)
    if (accessTypes.includes(user?.accessType)) {
      const providerOptions = Object.values(provider || {}).map(prov => ({
        label: prov.name || prov.label,
        value: prov.key,
        key: prov.key
      }));

      if (providerOptions.length > 0) {
        filterComponents.push(
          <Colxx xxs="12" md="3" key="providers" className='mb-3' >
            <Select
              isClearable={true}
              isMulti={true}
              placeholder="Filter by Service Providers"
              name="providers"
              options={providerOptions}
              className="basic-multi-select"
              classNamePrefix="select"
              value={filters?.providers && filters.providers.length > 0
                ? providerOptions.filter(p => filters.providers.includes(p.key))
                : []
              }
              onChange={val => {
                setFilters(prev => ({
                  ...prev,
                  providers: (val && val.length > 0) ? val.map(v => v.key) : []
                }));
              }}
            />
          </Colxx>
        );
      }
    }

    // Services filter
    const serviceOptions = Object.values(activeServices || {}).map(service => ({
      label: service.name || service.label,
      value: service.key,
      key: service.key
    }));

    if (serviceOptions.length > 0) {
      filterComponents.push(
        <Colxx xxs="12" md="3" key="services" className='mb-3' >
          <Select
            isClearable={true}
            isMulti={true}
            placeholder="Filter by Services"
            name="services"
            options={serviceOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            value={filters?.services && filters.services.length > 0
              ? serviceOptions.filter(s => filters.services.includes(s.key))
              : []
            }
            onChange={val => {
              setFilters(prev => ({
                ...prev,
                services: (val && val.length > 0) ? val.map(v => v.key) : []
              }));
            }}
          />
        </Colxx>
      );
    }

    // Washers filter
    const washerOptions = Object.values(washers || {}).map(washer => ({
      label: washer.name || washer.label,
      value: washer.key,
      key: washer.key
    }));

    if (washerOptions.length > 0) {
      filterComponents.push(
        <Colxx xxs="12" md="3" key="washers" className='mb-3' >
          <Select
            isClearable={true}
            isMulti={true}
            placeholder="Filter by Workers"
            name="washers"
            options={washerOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            value={filters?.washers && filters.washers.length > 0
              ? washerOptions.filter(w => filters.washers.includes(w.key))
              : []
            }
            onChange={val => {
              setFilters(prev => ({
                ...prev,
                washers: (val && val.length > 0) ? val.map(v => v.key) : []
              }));
            }}
          />
        </Colxx>
      );
    }

    return filterComponents.length > 0 ? <>{filterComponents}</> : null;
  }, [provider, washers, activeServices, user?.accessType, filters]);

  return (
    <div>
      {createNewOrder ?

        <Card className="rounded h-100">
          <CardBody>
            <AddNewAppointment
              bookings={bookings}
              activeServices={activeServices}
              washers={washers}
              toggleModal={() => setCreateNewOrder(false)}
              dismiss={() => setCreateNewOrder(false)}
            />
          </CardBody>
        </Card>

        :
        <>
          {selectedBooking && <Order
            bookings={bookings}
            washers={washers}
            providers={provider}
            activeServices={activeServices}
            toggleModal={toggleModal}
            dismiss={dismiss}
            selectedBooking={JSON.parse(JSON.stringify(selectedBooking))}
          />}
          <Modal
            isOpen={!!acceptAction}
            backdrop="static"
          >
            <ModalHeader>Accept Appointment</ModalHeader>
            <ModalBody>
              <div>Are you sure you want to accept this appointment?</div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="danger"
                outline
                onClick={() => {
                  setAcceptAction(false);
                }}
              >
                Dismiss
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  if (!acceptAction) return;

                  // For quickWash or SOS recovery orders, show assignment modal
                  if (acceptAction.service_type === 'quickWash' || 
                      (acceptAction.service_type === 'recovery' && acceptAction.recoveryInfo?.scheduleType === 'sos')) {
                    setAcceptAction(false);
                    // Auto-select provider for non-accessTypes users (providers)
                    if (!accessTypes.includes(user?.accessType)) {
                      const currentProvider = Object.values(provider || {}).find(p => p.key === user?.uid);
                      if (currentProvider) {
                        setSelectedSP(currentProvider);
                      }
                    }
                    setQuickWashAssignmentModal(true);
                    return;
                  }

                  // For regular orders, update status directly
                  firestore().collection(ORDER_COLLECTION).doc(acceptAction.key).update({
                    status: 'accepted',
                    updated: Date.now()
                  }).then(function () {
                    firestore().collection('logs').doc(acceptAction.key).set({
                      data: firestore.FieldValue.arrayUnion({
                        title: 'statusChanged',
                        created: Date.now(),
                        oldsStatus: acceptAction.status,
                        status: 'accepted',
                        createdBy: accessTypesObject?.[user?.accessType]?.name,
                        createdByName: user?.displayName
                      }),
                      updated: Date.now()
                    }, { merge: true }).then(function () {
                      setAcceptAction(false);
                    }).catch(error => {
                      console.error('Error updating logs:', error);
                      setAcceptAction(false);
                    });
                  }).catch(error => {
                    console.error('Error updating appointment:', error);
                    setAcceptAction(false);
                  });
                }}
              >
                Accept
              </Button>
            </ModalFooter>
          </Modal>

          {/* Reject Order Modal */}
          <Modal isOpen={!!rejectAction} backdrop="static">
            <ModalHeader>Reject Appointment</ModalHeader>
            <ModalBody>
              {/* For quickWash/recovery SOS orders being rejected by providers */}
              {!accessTypes.includes(user?.accessType) && 
               (rejectAction?.service_type === 'quickWash' || (rejectAction?.service_type === 'recovery' && rejectAction?.recoveryInfo?.scheduleType === 'sos')) ? (
                <div>
                  <p>Are you sure you want to reject this order?</p>
                </div>
              ) : (
                // For admins rejecting orders
                <div>
                  <Label>Rejection Reason *</Label>
                  <Input
                    type="textarea"
                    placeholder="Enter rejection reason"
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e.target.value)}
                    rows={4}
                    className="mt-2"
                  />
                </div>
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="primary" outline onClick={() => {
                setRejectAction(false);
                setRejectionReason('');
              }}>
                Dismiss
              </Button>
              <Button color="danger" onClick={() => {
                if (!rejectAction) return;

                // Handle quickWash/recovery SOS rejection by providers
                if (!accessTypes.includes(user?.accessType) && 
                    (rejectAction?.service_type === 'quickWash' || (rejectAction?.service_type === 'recovery' && rejectAction?.recoveryInfo?.scheduleType === 'sos'))) {
                  
                  firestore().collection(ORDER_COLLECTION).doc(rejectAction.key).update({
                    serviceProviders: firestore.FieldValue.arrayRemove(user?.uid),
                    updated: Date.now()
                  }).then(function () {
                    setRejectAction(false);
                    setRejectionReason('');

                    createNotification('warning', 'You have rejected this order', 'Success');
                  }).catch(function (error) {
                    console.error("Error writing document: ", error);
                    createNotification('error', 'Failed to reject order', 'Error');
                  });
                  return;
                }

                // Handle admin rejection with reason
                if (!rejectionReason.trim()) {
                  return createNotification('error', 'Please enter a rejection reason', 'Error');
                }

                firestore().collection(ORDER_COLLECTION).doc(rejectAction.key).update({
                  status: 'rejected',
                  cancelReason: rejectionReason.trim(),
                  updated: Date.now()
                }).then(function () {
                  firestore().collection('logs').doc(rejectAction.key).set({
                    data: firestore.FieldValue.arrayUnion({
                      title: 'statusChanged',
                      created: Date.now(),
                      oldsStatus: rejectAction.status,
                      status: 'rejected',
                      cancelReason: rejectionReason.trim(),
                      createdBy: accessTypesObject?.[user?.accessType]?.name,
                      createdByName: user?.displayName
                    }),
                    updated: Date.now()
                  }, { merge: true }).catch(error => error);

                  setRejectAction(false);
                  setRejectionReason('');

                  createNotification('success', 'Order rejected successfully', 'Success');
                }).catch(function (error) {
                  console.error("Error writing document: ", error);
                  createNotification('error', 'Failed to reject order', 'Error');
                });
              }}
              disabled={accessTypes.includes(user?.accessType) && !rejectionReason.trim()}
              >
                Reject Appointment
              </Button>
            </ModalFooter>
          </Modal>

          {/* QuickWash/Recovery Assignment Modal */}
          <Modal isOpen={quickWashAssignmentModal} backdrop="static" size="lg">
            <ModalHeader>Assign {acceptAction?.service_type === 'recovery' ? 'Recovery' : 'Quick Wash'} Order</ModalHeader>
            <ModalBody>
              <Row>
                {accessTypes.includes(user?.accessType) && (
                  <Colxx xxs="12" className="mb-3">
                    <Label>Select Service Provider *</Label>
                    <Select
                      placeholder="Select Service Provider"
                      value={selectedSP ? { label: selectedSP.name, value: selectedSP.key, key: selectedSP.key } : null}
                      onChange={(val) => {
                        setSelectedSP(val ? Object.values(provider).find(p => p.key === val.key) : null);
                        setSelectedWasher(null); // Reset washer when SP changes
                      }}
                      options={(() => {
                        // Filter providers based on order's serviceProviders property (array of SP IDs)
                        const orderServiceProviderIds = acceptAction?.serviceProviders || [];
                        let availableProviders = Object.values(provider || {});
                        
                        // If order has serviceProviders property, filter by it
                        if (orderServiceProviderIds.length > 0) {
                          availableProviders = availableProviders.filter(prov => 
                            orderServiceProviderIds.includes(prov.key)
                          );
                        }
                        
                        return availableProviders.map(prov => ({
                          label: prov.name || prov.label,
                          value: prov.key,
                          key: prov.key
                        }));
                      })()}
                      className="react-select"
                      classNamePrefix="react-select"
                      // menuPortalTarget={document.body}
                      // menuPosition="fixed"
                      // styles={{
                      //   menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      // }}
                    />
                  </Colxx>
                )}
                <Colxx xxs="12" className="mb-3">
                  <Label>Select Worker *</Label>
                  <Select
                    placeholder="Select Worker"
                    value={selectedWasher ? { label: selectedWasher.name, value: selectedWasher.key, key: selectedWasher.key } : null}
                    onChange={(val) => {
                      setSelectedWasher(val ? Object.values(washers).find(w => w.key === val.key) : null);
                    }}
                    options={(() => {
                      // Filter washers based on order's workers property (array of worker IDs)
                      const orderWorkerIds = acceptAction?.workers || [];
                      let availableWashers = Object.values(washers || {});
                      
                      // If order has workers property, filter by it
                      if (orderWorkerIds.length > 0) {
                        availableWashers = availableWashers.filter(washer => 
                          orderWorkerIds.includes(washer.key)
                        );
                      }
                      
                      // Filter by selected SP or user.uid for providers
                      const spIdToFilter = selectedSP ? selectedSP.key : (!accessTypes.includes(user?.accessType) ? user?.uid : null);
                      if (spIdToFilter) {
                        availableWashers = availableWashers.filter(washer => 
                          washer.sp_id === spIdToFilter
                        );
                      }
                      
                      return availableWashers.map(washer => ({
                        label: washer.name || washer.label,
                        value: washer.key,
                        key: washer.key
                      }));
                    })()}
                    isDisabled={!selectedSP && accessTypes.includes(user?.accessType)}
                    className="react-select"
                    classNamePrefix="react-select"
                    // menuPortalTarget={document.body}
                    // menuPosition="fixed"
                    // styles={{
                    //   menuPortal: (base) => ({ ...base, zIndex: 9999 })
                    // }}
                  />
                  {!selectedSP && accessTypes.includes(user?.accessType) && (
                    <small className="text-muted">Please select a Service Provider first</small>
                  )}
                </Colxx>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" outline onClick={() => {
                setQuickWashAssignmentModal(false);
                setSelectedSP(null);
                setSelectedWasher(null);
                setAcceptAction(null);
              }}>
                Cancel
              </Button>
              <Button 
                color="primary" 
                onClick={() => {
                  // For providers, use user.uid as sp_id if selectedSP is not set
                  const spToUse = selectedSP || (!accessTypes.includes(user?.accessType) ? Object.values(provider || {}).find(p => p.key === user?.uid) : null);
                  
                  if (!spToUse || !selectedWasher) {
                    return createNotification('error', 'Please select both Service Provider and Worker', 'Error');
                  }

                  if (!acceptAction) return;

                  const newItem = {
                    updated: Date.now(),
                    status: 'accepted',
                    sp_id: spToUse.key,
                    sp_name: spToUse.name,
                    sp_name_ar: spToUse.namear || spToUse.name,
                    washer_id: selectedWasher.key,
                    washer_name: selectedWasher.name,
                  };

                  firestore().collection(ORDER_COLLECTION).doc(acceptAction.key).update(newItem).then(function () {
                    firestore().collection('logs').doc(acceptAction.key).set({
                      data: firestore.FieldValue.arrayUnion({
                        title: 'statusChanged',
                        created: Date.now(),
                        oldsStatus: acceptAction.status,
                        status: 'accepted',
                        createdBy: accessTypesObject?.[user?.accessType]?.name,
                        createdByName: user?.displayName
                      }),
                      updated: Date.now()
                    }, { merge: true }).catch(error => error);

                    setQuickWashAssignmentModal(false);
                    setSelectedSP(null);
                    setSelectedWasher(null);
                    setAcceptAction(null);

                    createNotification('success', `${acceptAction?.service_type === 'recovery' ? 'Recovery' : 'Quick Wash'} order assigned successfully`, 'Success');
                  }).catch(function (error) {
                    console.error("Error writing document: ", error);
                    createNotification('error', 'Failed to assign order', 'Error');
                  });
                }}
                disabled={
                  (accessTypes.includes(user?.accessType) && !selectedSP) || 
                  !selectedWasher ||
                  (!accessTypes.includes(user?.accessType) && !Object.values(provider || {}).find(p => p.key === user?.uid))
                }
              >
                Assign Order
              </Button>
            </ModalFooter>
          </Modal>
          <ActiveHelper
            data={filteredBookings || []}
            title="New Requests"
            selected='requests'
            tableColumns={tableColumns}
            defaultSorting="bookingDate"
            filters={filters}
            filterComponent={filterComponent}
            sortDirection={'asc'}
            renderAsModal={true}
            hideDefaultDeleteButton={true}
            modalSize='lg'
            modalBackdrop='static'
            customEditTitle={(e) => {
              // Show "Accept" button for quickWash or SOS recovery orders
              if (e?.service_type === 'quickWash' || 
                  (e?.service_type === 'recovery' && e?.recoveryInfo?.scheduleType === 'sos')) {
                return 'Accept';
              }
              return 'View';
            }}
            customEditFunction={(e) => {
              if (!e) return;

              // Handle quickWash or SOS recovery orders - show assignment modal directly
              if (e?.service_type === 'quickWash' || 
                  (e?.service_type === 'recovery' && e?.recoveryInfo?.scheduleType === 'sos')) {
                // Set acceptAction to store the order data
                setAcceptAction(e);
                // Auto-select provider for non-accessTypes users (providers)
                if (!accessTypes.includes(user?.accessType)) {
                  const currentProvider = Object.values(provider || {}).find(p => p.key === user?.uid);
                  if (currentProvider) {
                    setSelectedSP(currentProvider);
                  }
                }
                // Show assignment modal directly
                setQuickWashAssignmentModal(true);
                return;
              } else {
                setSelectedBooking(e || {});
              }
            }}
            customRowClickFunction={(e) => {
              // Row click always opens order details, even for delayed orders
              if (e) {
                setSelectedBooking(e);
              }
            }}
            showCreateButton={!accessTypes.includes(user?.accessType)}
            customCreateFunction={(e) => {
              console.log(e)
              setCreateNewOrder(true)
            }}
            customActionButtons={[
              {
                accessor: "reject",
                func: (e) => {
                  if (!e) return;
                  setRejectAction(e);
                },
                color: "danger",
                title: 'Reject',
                show: (e) => {
                  // Show reject button only for new/pending orders
                  return ['new', 'pending'].includes(e?.status);
                }
              }
            ]}
          />
        </>
      }
    </div>
  );
};

export default Requests;
